'use client'

import { useSignals } from '@preact/signals-react/runtime'
import { NavCloseButton } from '@susu/headless-commerce/features/navigation/components/NavCloseButton'
import { NavSearchInput } from '@susu/headless-commerce/features/navigation/components/NavSearchInput'
import { ClientNavSearchResults } from '@susu/headless-commerce/features/navigation/components/NavSearchResults'
import classNames from 'classnames'
import { useI18N } from 'packages/i18n/dist/client'
import { useClientNav } from '../ClientNavProvider'
import { NavBack } from '../NavBack'
import navSubmenuStyles from '../NavSubmenu/NavSubmenu.module.scss'
import styles from './NavSearchPanel.module.scss'

export type NavSearchPanelProps = {
  searchPanelOpenedFrom: 'header' | 'menu'
}

export const NavSearchPanel = ({
  searchPanelOpenedFrom,
}: NavSearchPanelProps) => {
  useSignals()

  const { t } = useI18N()
  const { isSearchMenuOpened } = useClientNav()

  const searchPanelClass = classNames(
    'nav__search-panel',
    navSubmenuStyles['nav__submenu'],
    'nav__submenu',
    {
      [`${navSubmenuStyles['nav__submenu--opened']} nav__submenu--opened`]:
        isSearchMenuOpened.value,
      [navSubmenuStyles['nav__submenu--opened-from-header']]:
        searchPanelOpenedFrom === 'header',
    },
  )

  return (
    <div className={searchPanelClass} data-testid="nav-search-panel">
      {/* Hide back back button when search panel is opened from header. */}
      {searchPanelOpenedFrom === 'menu' ? <NavBack /> : null}
      <NavCloseButton className={'nav__submenu-close-btn'} />
      <span className={`${styles['nav__search-title']} nav__submenu-title`}>
        {t('navigation.search')}
      </span>
      <div className={styles['nav__search-input-wrap']}>
        <NavSearchInput />
      </div>
      <ClientNavSearchResults searchPanelOpenedFrom={searchPanelOpenedFrom} />
    </div>
  )
}
